import { useEffect } from "react";
import { useHeader } from "@/context/HeaderTitleContext";

const useHeaderTitle = (title: string) => {
    const { setTitle } = useHeader();

    useEffect(() => {
        setTitle(title);
    }, [title]);
}

export default useHeaderTitle;